import forceload from "../../../../content/posts/2021-01-05-2020-year-in-review/images/cp2077_1.webp";
import * as React from 'react';
export default {
  forceload,
  React
};